// extracted by mini-css-extract-plugin
export default {"tableWrap":"styles_tableWrap__fmAr2"};